const normalizeApiBaseUrl = (url: string) => url.replace(/\/api\/?$/, '');

const getApiUrl = () => {
  return normalizeApiBaseUrl(import.meta.env.VITE_API_URL as string);
};

const getPortalUrl = () => {
  return import.meta.env.VITE_PORTAL_URL as string;
};

const getWebsocketApiBase = () => {
  return import.meta.env.VITE_WEBSOCKET_API_BASE as string;
};

const getMapboxAccessToken = () => {
  return import.meta.env.VITE_MAPBOX_ACCESS_TOKEN as string;
};

const getMapboxStyle = () => {
  return import.meta.env.VITE_MAPBOX_STYLE as string;
};

export {
  getApiUrl,
  getPortalUrl,
  getWebsocketApiBase,
  getMapboxAccessToken,
  getMapboxStyle,
};
